import React, { useEffect, useRef, useState } from 'react';
import { Collapse, Grid, Typography } from '@mui/material';
import DatasetIcon from '@mui/icons-material/Dataset';
// import VideoIcon from '@mui/icons-material/SmartDisplayOutlined';
// import FaqIcon from '@mui/icons-material/ContactSupportOutlined';

import { DataCatalogHandler } from './DataCatalogHandler';

import { useSpread } from '../../services/store/Spread';
import { translate } from '../../utils/translations';

import * as S from './styles';

export function Sidebar({
  initDataset = false,
  setFormatFileLoaded,
}: {
  initDataset?: boolean;
  setFormatFileLoaded?: (
    nextState: boolean | ((prevState: boolean) => boolean)
  ) => void;
}): React.JSX.Element {
  const [dataset, setDataset] = useState(false);
  const { isDetail } = useSpread();
  const sidebarRef = useRef(null);

  useEffect(() => {
    setDataset(initDataset);
  }, [initDataset]);

  return (
    <Grid container sx={{ height: '100%' }}>
      <Grid size="auto">
        <S.SidebarWrapper ref={sidebarRef}>
          <Grid container flexDirection="column" sx={{ height: '100%' }}>
            <Grid size="grow">
              <S.SidebarButton
                sx={(theme) => ({
                  color: dataset
                    ? theme.palette.primary.main
                    : theme.palette.text.primary,
                  backgroundColor: dataset
                    ? theme.palette.primary.light
                    : 'inherit',
                })}
                onClick={() => setDataset(true)}
                disabled={isDetail}
              >
                <DatasetIcon sx={{ mb: 0.5 }} />
                <Typography variant="bodyXs" sx={{ whiteSpace: 'pre-line' }}>
                  {translate('DATA_CATALOG')}
                </Typography>
              </S.SidebarButton>
            </Grid>
            {/* @TODO ヘルプセンター等について作成が完了したら実装する */}
            {/* <Grid
              container
              size="auto"
              flexDirection="column"
              spacing={1}
              width="100%"
            >
              <Grid size="auto">
                <S.SidebarButton>
                  <VideoIcon sx={{ mb: 0.5 }} />
                  <Typography variant="bodyXs">{translate('VIDEO')}</Typography>
                </S.SidebarButton>
              </Grid>
              <Grid size="auto">
                <S.SidebarButton>
                  <FaqIcon sx={{ mb: 0.5 }} />
                  <Typography variant="bodyXs">{translate('FAQ')}</Typography>
                </S.SidebarButton>
              </Grid>
            </Grid> */}
          </Grid>
        </S.SidebarWrapper>
      </Grid>
      <Collapse in={dataset} orientation="horizontal">
        <DataCatalogHandler
          onClose={() => setDataset(false)}
          setFormatFileLoaded={setFormatFileLoaded}
        />
      </Collapse>
    </Grid>
  );
}
